export default __webpack_public_path__ + "media/zurb/img/icons/services/mobile-1eb8da596859b0050416245350286284.svg";